import { gtagEvent } from "./googleDataLayer.js";
export const addToCartButton = (el) => {
  const $body = $("body");

  $body.on("click", '[data-button-action="add-to-cart"]', (event) => {
    event.preventDefault();
    let tailleChoisie = ctrlTailleChoisie();

    if (tailleChoisie === false) {
      return false;
    }

    //gtag_report_conversion();
    gtagEvent("add_to_cart");


    const $form = $(event.target.form);
    const query = `${$form.serialize()}&add=1&action=update`;
    const actionURL = $form.attr("action");
    const addToCartButton = $(event.target);

    addToCartButton.prop("disabled", true);

    const isQuantityInputValid = ($input) => {
      let validInput = true;

      $input.each((index, input) => {
        const $currentInput = $(input);
        const minimalValue = parseInt($currentInput.attr("min"), 10);

        if (minimalValue && $currentInput.val() < minimalValue) {
          onInvalidQuantity($currentInput);
          validInput = false;
        }
      });

      return validInput;
    };

    let onInvalidQuantity = ($input) => {
      $input
        .parents(prestashop.selectors.product.addToCart)
        .first()
        .find(prestashop.selectors.product.minimalQuantity)
        .addClass("error");
      $input.parent().find("label").addClass("error");
    };

    const $quantityInput = $form.find("input[min]");

    if (!isQuantityInputValid($quantityInput)) {
      onInvalidQuantity($quantityInput);

      return;
    }
    addToCartButton.prop("disabled", true);
    $.post(actionURL, query, null, "json")
      .then((resp) => {
        if (resp.errors.length) {
          import(
            /* webpackChunkName: "dialog" */
            "../dialog.js"
          ).then((dialogImport) => {

            dialogImport.dialog({
              titleColor: "#ff0000",
              type: "error",
              title: "Taille :",
              message: resp.errors[0],
            });

          });
        }
        prestashop.emit("updateCart", {
          reason: {
            idProduct: resp.id_product,
            idProductAttribute: resp.id_product_attribute,
            idCustomization: resp.id_customization,
            linkAction: "add-to-cart",
            cart: resp.cart,
          },
          resp,
        });
      })
      .fail((resp) => {
        prestashop.emit("handleError", {
          eventType: "addProductToCart",
          resp,
        });
      })
      .always(() => {
        setTimeout(() => {
          addToCartButton.prop("disabled", false);
        }, 1000);
      });
  });
};

export const ctrlTailleChoisie = () => {
  let id_attribute = false;
  let hasError = false;
  $('.taille_choisie').each(function (index, element) {
    id_attribute = parseInt($(this).attr("data-taille"));
    if (id_attribute < 1) {
      hasError = true;
      import(
        /* webpackChunkName: "dialog" */
        "../dialog.js"
      ).then((dialogImport) => {

        dialogImport.dialog({
          titleColor: "#ff0000",
          type: "error",
          title: "Taille :",
          message: "Merci de choisir une taille avant d'ajouter au panier.",
        });

      });
    }
  });
  if (hasError === true) {
    return false;
  }
  return true;
};
